export default __webpack_public_path__ + "static/monstaintro-5111237b422884ecc4e6a44851e6dff3.png";